// extracted by mini-css-extract-plugin
module.exports = {"search-box":"N_fn","search-box__input":"N_fp form-control","search-box__icon":"N_fq ml-2"};